<template>
  <div>
    <v-flex v-if="execution.executionType === 'WORKFLOW'" class="pa-2">
      <v-layout row wrap>
        <v-flex class="my-2" xs12>
          <v-card
            v-if="execution.message"
            :class="$vuetify.dark ? 'card-dark ' : 'card-light '"
            flat
          >
            <v-toolbar
              dense
              flat
              @click="showWorkflowOutput = !showWorkflowOutput"
            >
              <v-toolbar-title
                class="body-2 beez-bold "
                v-text="'Workflow Message'"
              />
              <v-spacer />
              <v-btn class="mb-2" icon small>
                <v-icon
                  >{{
                    showWorkflowOutput
                      ? 'keyboard_arrow_up'
                      : 'keyboard_arrow_down'
                  }}
                </v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text
              v-if="showWorkflowOutput && can('EXECUTION_WORKFLOW_MESSAGE')"
            >
              <v-flex xs12>
                <v-textarea
                  v-if="execution.message"
                  :key="execution.hexId + 'execution-message'"
                  :outline="$vuetify.dark"
                  :value="execution.message"
                  color="secondary"
                  label="Workflow Message"
                  readonly
                />
              </v-flex>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card :class="$vuetify.dark ? 'card-dark ' : 'card-light '" flat>
            <v-toolbar dense flat @click="showProcessView = !showProcessView">
              <v-toolbar-title
                class="body-2 beez-bold "
                v-text="'Process View'"
              />
              <v-spacer />
              <v-btn class="mb-2" icon small>
                <v-icon
                  >{{
                    showProcessView
                      ? 'keyboard_arrow_up'
                      : 'keyboard_arrow_down'
                  }}
                </v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text v-if="showProcessView">
              <execution-process
                :execution="execution"
                @activitySelected="handleActivitySelection"
              >
              </execution-process>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-tabs
        v-if="execution.executionType === 'WORKFLOW'"
        v-model="executionTabs"
        slider-color="secondary"
      >
        <v-tabs-slider color="secondary" />
        <v-tab
          v-if="can('EXECUTION_DETAILS_VIEW')"
          :key="execution.hexId + 'execution-details-list'"
        >
          <span class="text-capitalize">Workflow Execution View</span>
        </v-tab>
        <v-tab
          v-if="can('EXECUTION_VIEW')"
          :key="execution.hexId + 'execution-list'"
        >
          <span class="text-capitalize">Bot View</span>
        </v-tab>
        <v-tab
          v-if="can('EXECUTION_ACTIVITY_VIEW')"
          :key="execution.hexId + 'activity-list'"
        >
          <span class="text-capitalize">Activity view</span>
        </v-tab>
        <v-tab
          v-if="can('EXECUTION_DATAFLOW_VIEW')"
          :key="execution.hexId + 'graph-view'"
        >
          <span class="text-capitalize">Data-Flow View</span>
        </v-tab>
        <v-tab
          v-if="can('EXECUTION_VARIABLES')"
          :key="execution.hexId + 'execution-variables-view'"
        >
          <span class="text-capitalize">Process Variables</span>
        </v-tab>
        <v-tab
          v-if="can('EXECUTION_EMAIL')"
          :key="execution.hexId + 'execution-mail-view'"
        >
          <span class="text-capitalize">Outbound Emails</span>
        </v-tab>
        <v-tab
          v-if="can('EXECUTION_TASKS')"
          :key="execution.hexId + 'execution-tasks-view'"
        >
          <span class="text-capitalize">User Tasks</span>
        </v-tab>
        <v-tab
          v-if="can('EXECUTION_DOCS')"
          :key="execution.hexId + 'execution-docs-view'"
        >
          <span class="text-capitalize">Documents created</span>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="executionTabs">
        <v-tab-item
          :key="execution.hexId + 'execution-details-view'"
          v-if="can('EXECUTION_DETAILS_VIEW')"
        >
          <execution-workflow-details :execution="execution" />
        </v-tab-item>
        <v-tab-item
          :key="execution.hexId + 'execution-list'"
          v-if="can('EXECUTION_VIEW')"
        >
          <div v-if="executionTabs === 1">
            <execution-bots
              :execution="execution"
              :show-id="showId"
              :selected-execution-id="selectedBotExecution"
              @clearAllSelections="handleClearAllSelections"
            />
          </div>
        </v-tab-item>
        <v-tab-item
          :key="execution.hexId + 'activity-list'"
          v-if="can('EXECUTION_ACTIVITY_VIEW')"
          ><div v-if="executionTabs === 2">
            <execution-activities
              :execution="execution"
              :selected-activity-id="selectedActivity"
              @goToBotExecution="handleBotExecutionSelection"
              @clearAllSelections="handleClearAllSelections"
            />
          </div>
        </v-tab-item>
        <v-tab-item
          :key="execution.hexId + 'graph-view'"
          v-if="can('EXECUTION_DATAFLOW_VIEW')"
        >
          <div v-if="executionTabs === 3">
            <execution-graph :execution="execution" />
          </div>
        </v-tab-item>
        <v-tab-item
          :key="execution.hexId + 'execution-variable-view'"
          v-if="can('EXECUTION_VARIABLES')"
        >
          <div v-if="executionTabs === 4">
            <execution-variable :execution="execution" />
          </div>
        </v-tab-item>
        <v-tab-item
          :key="execution.hexId + 'execution-mail-view'"
          v-if="can('EXECUTION_EMAIL')"
        >
          <div v-if="executionTabs === 5">
            <execution-email :execution="execution" />
          </div>
        </v-tab-item>
        <v-tab-item
          :key="execution.hexId + 'execution-task-view'"
          v-if="can('EXECUTION_TASKS')"
        >
          <div v-if="executionTabs === 6">
            <execution-tasks :execution="execution" />
          </div>
        </v-tab-item>
        <v-tab-item
          :key="execution.hexId + 'execution-docs-view'"
          v-if="can('EXECUTION_DOCS')"
        >
          <div v-if="executionTabs === 7">
            <execution-documents :execution="execution" />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-flex>
    <v-flex v-else class="pa-2">
      <template>
        <v-card :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
          <v-card-text>
            <v-layout class="row wrap">
              <v-flex xs12>
                <execution-bot-detail :executionInput="execution" />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </template>
    </v-flex>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ExecutionBotDetail from '@/components/execution/ExecutionBotDetail.vue'
import ExecutionActivityDetail from './ExecutionActivityDetail.vue'
import ExecutionGraph from './ExecutionGraph'
import ExecutionEmail from '@/components/execution/ExecutionEmail.vue'
import ExecutionTasks from '@/components/execution/ExecutionTasks.vue'
import ExecutionBots from '@/components/execution/ExecutionBots.vue'
import ExecutionDocuments from '@/components/execution/ExecutionDocuments.vue'
import ExecutionActivities from '@/components/execution/ExecutionActivities.vue'
import ExecutionProcess from '@/components/execution/ExecutionProcess.vue'
import ExecutionVariable from '@/components/execution/ExecutionProcessVariables.vue'
import ExecutionWorkflowDetails from '@/components/execution/ExecutionWorkflowDetails.vue'

export default {
  name: 'ExecutionDetail',
  components: {
    ExecutionBotDetail,
    ExecutionActivityDetail,
    ExecutionGraph,
    ExecutionEmail,
    ExecutionActivities,
    ExecutionDocuments,
    ExecutionBots,
    ExecutionTasks,
    ExecutionProcess,
    ExecutionVariable,
    ExecutionWorkflowDetails
  },
  computed: {
    ...mapGetters({
      can: 'can'
    })
  },
  props: {
    execution: {
      type: Object,
      required: true
    },
    showId: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      executionTabs: null,
      showWorkflowOutput: false,
      showProcessView: false,
      expanded: false,
      selectedActivity: null,
      selectedBotExecution: null
    }
  },
  methods: {
    handleActivitySelection(activity) {
      this.executionTabs = 2
      this.selectedActivity = activity
    },
    handleBotExecutionSelection(executionId) {
      this.executionTabs = 1
      this.selectedBotExecution = executionId
    },
    handleClearAllSelections() {
      this.selectedActivity = null
      this.selectedBotExecution = null
    }
  }
}
</script>

<style scoped></style>
